import { render, staticRenderFns } from "./groupList.vue?vue&type=template&id=ff3710ee&scoped=true"
import script from "./groupList.vue?vue&type=script&lang=js"
export * from "./groupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3710ee",
  null
  
)

export default component.exports